import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from './components/ui/toaster';
import TopBar from './components/TopBar';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Categories from './components/Categories';
import ConexaoGlobal from './components/ConexaoGlobal';
import Missao from './components/Missao';
import PlayGame from './components/PlayGame';
import Distribuidor from './components/Distribuidor';
import Footer from './components/Footer';
import Torneios from './pages/Torneios';

function Home() {
  React.useEffect(() => {
    const el = window.location.hash && document.querySelector(window.location.hash);
    if (el) setTimeout(() => el.scrollIntoView(), 100);
  }, []);
  return (
    <div className="App min-h-screen">
      <TopBar />
      <Navbar />
      <Hero />
      <Categories />
      <ConexaoGlobal />
      <Missao />
      <PlayGame />
      <Distribuidor />
      <Footer />
      <Toaster />
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/torneios" element={<Torneios />} />
      </Routes>
    </BrowserRouter>
  );
}
